// PC版案件詳細ページのメイン画像カルーセル（keen-slider）

import KeenSlider, { KeenSliderInstance } from 'keen-slider'

// keen-sliderインスタンスを保持するHTML要素の型
interface KeenSliderElement extends HTMLElement {
  keenSlider?: KeenSliderInstance
}

// サムネイルクリック時にメインスライダーを連動させるプラグイン
function ThumbnailPlugin(mainSlider: KeenSliderInstance) {
  return (slider: KeenSliderInstance) => {
    function removeActive() {
      slider.slides.forEach((slide) => {
        slide.classList.remove('border-brand-red')
        slide.classList.add('border-transparent')
      })
    }

    function addActive(idx: number) {
      slider.slides[idx]?.classList.add('border-brand-red')
      slider.slides[idx]?.classList.remove('border-transparent')
    }

    // イベント委譲でクリックイベントを一括処理
    function addClickEvents() {
      slider.container.addEventListener('click', (e) => {
        const clickedSlide = (e.target as HTMLElement).closest('.keen-slider__slide')
        if (!clickedSlide) return

        const idx = Array.from(slider.slides).indexOf(clickedSlide as HTMLElement)
        if (idx !== -1) {
          mainSlider.moveToIdx(idx)
        }
      })
    }

    slider.on('created', () => {
      addClickEvents()
      addActive(slider.track.details.rel)
    })

    // サムネイルのスライド変更時にメインスライダーも連動
    slider.on('slideChanged', (s) => {
      removeActive()
      addActive(s.track.details.rel)
      mainSlider.moveToIdx(s.track.details.rel)
    })

    // メインスライダーの変更をサムネイルに反映
    mainSlider.on('slideChanged', (main) => {
      removeActive()
      addActive(main.track.details.rel)
      slider.moveToIdx(main.track.details.rel)
    })
  }
}

/**
 * PC版案件詳細ページのカルーセルを初期化
 */
export const initWorkDetailCarousel = (): void => {
  const mainCarousel = document.querySelector<KeenSliderElement>('.js-main-carousel')
  const thumbnailCarousel = document.querySelector<KeenSliderElement>('.js-thumbnail-carousel')

  if (mainCarousel === null) return

  if (mainCarousel.children.length < 2) return

  // すでに初期化済みの場合はスキップ
  if (mainCarousel.keenSlider) return

  let mainSlider: KeenSliderInstance | null = null

  mainSlider = new KeenSlider(mainCarousel, {
    slides: {
      perView: 1
    }
  })

  // サムネイルカルーセルがある場合のみサムネイル機能を初期化
  if (thumbnailCarousel !== null) {
    const thumbnailSlider = new KeenSlider(
      thumbnailCarousel,
      {
        slides: {
          perView: 'auto',
          spacing: 8
        },
        mode: 'free-snap'
      },
      [ThumbnailPlugin(mainSlider)]
    )

    thumbnailCarousel.keenSlider = thumbnailSlider
  }

  mainCarousel.keenSlider = mainSlider
}
